import cn from 'classnames'
import React from 'react'

import styles from './MenuList.module.scss'
import MenuListItem from './MenuListItem'
import MenuListLabel from './MenuListLabel'
import MenuListSubheading from './MenuListSubheading'

import Text from '~lib/ui-kit/Text'

/**
 * Use MenuList component when you need only styles and elements for building more complex components that use menu inside e.g.:
 *  - Menu
 *  - Select
 *  - Autocomplete
 *
 *  For complete menu that has all required navigation logic, including keyboard support, use Menu component.
 */

type ScrollingProp = {
  scrollActive?: boolean
}

export type MenuListProps = React.HTMLAttributes<HTMLUListElement> & ScrollingProp

function MenuListDivider({ label }: { label: string }) {
  return (
    <Text as="li" role="none" className={styles.divider} variant="secondary" type="caption" bold>
      {label}
    </Text>
  )
}

const MenuList = React.forwardRef<HTMLUListElement, MenuListProps>(
  ({ className = '', scrollActive = true, children, ...elemProps }, ref) => {
    return (
      <ul
        ref={ref}
        tabIndex={-1}
        role="menu"
        className={cn(styles.root, { [styles.withScroll]: scrollActive }, className)}
        {...elemProps}
      >
        {children}
      </ul>
    )
  }
)

export default Object.assign(MenuList, {
  Item: MenuListItem,
  Label: MenuListLabel,
  Subheading: MenuListSubheading,
  Divider: MenuListDivider,
})
